import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { TourProvider } from "@/contexts/TourContext";
import InterviewTranscript from "@/pages/InterviewTranscript";
import DemoPlayer from "@/pages/DemoPlayer";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import ConsultingChat from "@/pages/ConsultingChat";
import ExecutiveReport from "@/pages/ExecutiveReport";
import AgentChat from "@/pages/AgentChat";
import AgentEdit from "@/pages/AgentEdit";
import Dashboard from "@/pages/Dashboard";
import AgentMetrics from "@/pages/AgentMetrics";
import AdminPlans from "@/pages/AdminPlans";
import AdminBilling from "@/pages/AdminBilling";
import KblLibrary from "@/pages/KblLibrary";
import AdminLlmKeys from "@/pages/AdminLlmKeys";
import AdminIndustry from "@/pages/AdminIndustry";
import AdminUsers from "@/pages/AdminUsers";
import AdminTenants from "@/pages/AdminTenants";
import AdminDemo from "@/pages/AdminDemo";
import AgentMcps from "@/pages/AgentMcps";
import FlowDocument from "@/pages/FlowDocument";
import AgentQa from "@/pages/AgentQa";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <AuthProvider>
        <ThemeProvider>
        <BrowserRouter>
          <TourProvider>
          <Routes>
            {/* Public surfaces */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/consulta" element={<ConsultingChat />} />
            <Route path="/informe/:sid" element={<ExecutiveReport />} />
            <Route path="/agentes/:slug" element={<AgentChat />} />

            {/* Authenticated surfaces (any approved role) */}
            <Route path="/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/agentes/:slug/pruebas" element={
              <ProtectedRoute roles={["admin"]}><AgentQa /></ProtectedRoute>
            } />
            <Route path="/agentes/:slug/metricas" element={
              <ProtectedRoute><AgentMetrics /></ProtectedRoute>
            } />

            {/* Admin / Consultor surfaces */}
            <Route path="/demo/:token" element={<DemoPlayer />} />
            <Route path="/informe/:sid/flujo" element={<FlowDocument />} />
            <Route path="/informe/:sid/entrevista" element={
              <ProtectedRoute roles={["admin", "consultor"]}><InterviewTranscript /></ProtectedRoute>
            } />
            <Route path="/agentes/:slug/editar" element={
              <ProtectedRoute roles={["admin", "consultor"]}><AgentEdit /></ProtectedRoute>
            } />
            <Route path="/agentes/:slug/mcps" element={
              <ProtectedRoute roles={["admin", "consultor"]}><AgentMcps /></ProtectedRoute>
            } />
            <Route path="/admin/planes" element={
              <ProtectedRoute roles={["admin", "consultor"]}><AdminPlans /></ProtectedRoute>
            } />
            <Route path="/admin/facturacion" element={
              <ProtectedRoute roles={["admin", "consultor"]}><AdminBilling /></ProtectedRoute>
            } />
            <Route path="/admin/kbl" element={
              <ProtectedRoute roles={["admin", "consultor"]}><KblLibrary /></ProtectedRoute>
            } />
            <Route path="/admin/industria" element={
              <ProtectedRoute roles={["admin", "consultor"]}><AdminIndustry /></ProtectedRoute>
            } />

            {/* Admin-only */}
            <Route path="/admin/llm" element={
              <ProtectedRoute roles={["admin"]}><AdminLlmKeys /></ProtectedRoute>
            } />
            <Route path="/admin/usuarios" element={
              <ProtectedRoute roles={["admin"]}><AdminUsers /></ProtectedRoute>
            } />
            <Route path="/admin/demo" element={
              <ProtectedRoute roles={["admin"]}><AdminDemo /></ProtectedRoute>
            } />
            <Route path="/admin/tenants" element={
              <ProtectedRoute roles={["admin"]}><AdminTenants /></ProtectedRoute>
            } />
          </Routes>
          </TourProvider>
        </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0f172a",
            color: "#f8fafc",
            border: "1px solid #334155",
            borderRadius: 2,
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
